import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { RoleData } from '@interfaces/role/role-data';

export const initialValue: { roles: RoleData[] } = {
  roles: [],
};

export const RoleStore = signalStore(
  { providedIn: 'root' },
  withState(initialValue),
  withMethods(({ ...store }) => ({
    setRoles(roles: RoleData[]) {
      patchState(store, { roles });
    },
  })),
);
